interface SignatureCheck {
  offset: number
  bytes: number[]
}

interface ImageSignature {
  format: string
  checks: SignatureCheck[]
}

const IMAGE_SIGNATURES: ImageSignature[] = [
  { format: 'png', checks: [{ offset: 0, bytes: [0x89, 0x50, 0x4e, 0x47] }] },
  { format: 'jpeg', checks: [{ offset: 0, bytes: [0xff, 0xd8, 0xff] }] },
  { format: 'gif', checks: [{ offset: 0, bytes: [0x47, 0x49, 0x46, 0x38] }] },
  {
    format: 'webp',
    checks: [
      { offset: 0, bytes: [0x52, 0x49, 0x46, 0x46] },
      { offset: 8, bytes: [0x57, 0x45, 0x42, 0x50] },
    ],
  },
]

const bytesMatchAt = (view: Uint8Array, check: SignatureCheck): boolean => {
  return check.bytes.every(
    (expectedByte, index) => view[check.offset + index] === expectedByte
  )
}

const isValidImageSignature = async (file: File): Promise<boolean> => {
  try {
    const buffer = await file.slice(0, 12).arrayBuffer()
    const view = new Uint8Array(buffer)

    return IMAGE_SIGNATURES.some((signature) =>
      signature.checks.every((check) => bytesMatchAt(view, check))
    )
  } catch {
    return false
  }
}

const FileValidation = {
  IMAGE_SIGNATURES,
  isValidImageSignature,
}

export default FileValidation
